import slugify from 'slugify';
import store from '@/store/store.js';

const getInvestment = params => {
  if (!params.investment) {
    return null;
  }
  let investmentName = slugify(params.investment, {
    lower: true,
  });
  return store.state.browser.investments.get(investmentName) || null;
};

export const validateInvestment = params => {
  return Boolean(getInvestment(params));
};

const getBuilding = params => {
  if (!params.building) {
    return null;
  }

  let investment = getInvestment(params);

  if (investment) {
    let id = slugify(params.building, { lower: true });
    return investment.buildings.get(id);
  }

  return null;
};

export const validateBuilding = params => {
  return Boolean(getBuilding(params));
};

const getFloor = params => {
  if (!params.building) {
    return null;
  }

  let building = getBuilding(params);

  if (building) {
    let floors = building.floors.list;
    for (let floor of floors) {
      if (floor.level == params.floor) {
        return floor;
      }
    }
  }

  return null;
};

export const validateFloor = params => {
  return Boolean(getFloor(params));
};

export const ValidateFlat = (params, flat = null, flats = []) => {
  let investment = getInvestment(params);

  if (investment && flat == null && flats.length == 0) {
    return true;
  } else if (investment && flat && flats.length) {
    let ids = flats.map(f => f[store.state.browser.flatProperties['id']]);
    return ids.includes(flat[store.state.browser.flatProperties['id']]);
  }

  return false;
};
